import { CSSProperties, ReactElement, ReactNode } from 'react';
import { GraphTooltipContainer, MonthContainer } from './styles';
import { Divider } from 'pages/NewOverview/components/Divider';
import { colors } from 'styles/colors';
import { CalendarOutlined } from 'icons';
import { format } from 'date-fns';
import { defaultDateFnsLocale } from 'helpers/locale';
import { capitalizeFirstLetter } from 'helpers/capitalizeFirstLetter';

interface GraphTooltipProps {
  date: string;
  children: ReactNode;
  type: 'day' | 'month';
  style?: CSSProperties;
}

export function GraphTooltip({
  children,
  date,
  type,
  style,
}: Readonly<GraphTooltipProps>): ReactElement {
  const formattedDate = capitalizeFirstLetter(
    format(new Date(date), `${type === 'day' ? 'dd ' : ''}MMMM yyyy`, { locale: defaultDateFnsLocale }),
  );

  return (
    <GraphTooltipContainer style={style}>
      <MonthContainer>
        <CalendarOutlined color={colors.icon['primary-base']} size="16" />
        <span>{formattedDate}</span>
      </MonthContainer>
      <Divider style={{ width: '100%' }} />
      {children}
    </GraphTooltipContainer>
  );
}
